import NotificationsProvider from './Notifications.provider';

export default NotificationsProvider;